import Input from "@/components/fields/Input";
import {useAppState} from "@/store";

export default function PropertyFloorNumber({stateKey}) {
    const {state, setState} = useAppState()
    const handleChange = (v) => {
        setState((s) => {
            s[stateKey].floor = v.replace(/^0+/, '')
        })
    }

    return (
        <Input
            label={"Floor (not unit number)"}
            type={"text"}
            inputMode={"numeric"}
            maxLength={2}
            name={`${stateKey}.floor`}
            value={state[stateKey]?.floor || ''}
            placeholder={"Enter floor number"}
            onChange={handleChange}
            required
        />
    )
}
